import { STATIC_PARTICLE_NETWORK } from '../config';
export default class CommonApi {
    connection;
    constructor(connection) {
        this.connection = connection;
        this.connection = connection;
    }
    async getAllToken(chainName) {
        try {
            if (chainName === 'zksyncv2') {
                chainName = 'zksync';
            }
            let chainData = await fetch(`${STATIC_PARTICLE_NETWORK}/token-list/${chainName}.json?_=${Date.now()} `).then((res) => res.json());
            chainData.shortName = chainName;
            return chainData;
        }
        catch (error) {
            console.log('getAllToken error', error);
            return {
                name: 'ParticleNetwork',
                logoURI: '',
                timestamp: '',
                tokens: [],
            };
        }
    }
    async getUserSimpleInfo(params) {
        const { apiUrl, token, chainId, projectKey, projectAppUuid } = params;
        return this.connection.get(`${apiUrl}/apps/${projectAppUuid}/user-simple-info`, {
            params: {
                token,
                chainId,
                projectKey,
            },
        });
    }
}
//# sourceMappingURL=common-api.js.map